<template>
  <v-app>
    <slot />
  </v-app>
</template>

<script lang="ts">
import { mapActions } from "vuex";
import * as ACTION_TYPES from "../store/nights/action-types";
export default {
  async created() {
    await this.fetchDestinationCards();
  },
  methods: {
    ...mapActions({
      fetchDestinationCards: ACTION_TYPES.FETCH_DESTINATION_CARDS
    })
  }
};
</script>

<style lang="scss" scoped></style>
